/** @jsx createElement */
import { observer } from 'mobx-react';
import { createElement, Component, HTMLAttributes } from 'react';
import { Template__CrossTeamCommunication } from '../../templates/cross-team-communication';

@observer
export class Slide04 extends Component {
  componentDidMount() {
    // Do something
  }

  render() {
    const { children } = this.props;
    return (
      <div className={`slide-04`}>
        {children}
        <Template__CrossTeamCommunication />
      </div>
    );
  }
}
